import { render, staticRenderFns } from "./paymentOk.vue?vue&type=template&id=00842990&scoped=true&"
import script from "./paymentOk.vue?vue&type=script&lang=js&"
export * from "./paymentOk.vue?vue&type=script&lang=js&"
import style0 from "./paymentOk.vue?vue&type=style&index=0&id=00842990&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "00842990",
  null
  
)

export default component.exports